import { Subject } from 'rxjs'
import apiResponse from '../../../../../../../services/apiResponse'
import DiklatRepository from '../Repository/DiklatRepository'

class DiklatBloc {
    
    rowtableChannel = new Subject();
    inactiveChannel = new Subject();
    activeChannel = new Subject();
    approveChannel = new Subject();
    hoursChannel = new Subject();
    regionChannel = new Subject();
    regionCityChannel = new Subject();
    regionProvinceChannel = new Subject();
    rowtableAdminChannel = new Subject();
    repository = new DiklatRepository()

    constructor() {
        this.rowtableChannel.next({status: apiResponse.INITIAL})
        this.inactiveChannel.next({status: apiResponse.INITIAL})
        this.activeChannel.next({status: apiResponse.INITIAL})
        this.hoursChannel.next({status: apiResponse.INITIAL})
        this.approveChannel.next({status: apiResponse.INITIAL})
    }

    fetchRegionProvince = async (query) => {
        try {
            this.regionProvinceChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchRegionProvince(query).then((result) => {
                this.regionProvinceChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.regionProvinceChannel.next({status: apiResponse.ERROR, data: error})
            })   
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed')
        }
    }

    fetchRegionCity = async (query) => {
        try {
            this.regionCityChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchRegionCity(query).then((result) => {
                this.regionCityChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.regionCityChannel.next({status: apiResponse.ERROR, data: error})
            })           
        } catch (error) {
            console.log('rxjs', 'Error fetching')            
        }
    }

    fetchRowTable = async (query, cancelToken) => {
        try {
            this.rowtableChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchRowTable(query, cancelToken).then((result) => {
                this.rowtableChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.rowtableChannel.next({status: apiResponse.ERROR, data: error})
            })           
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed')
        }
    }

    fetchRowTableAdmin = async (query, cancelToken) => {
        try {
            this.rowtableAdminChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchRowTableAdmin(query, cancelToken).then((result) => {
                this.rowtableAdminChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.rowtableAdminChannel.next({status: apiResponse.ERROR, data: error})
            })           
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed')
        }
    }

    fetchInactive = async (query) => {
        try {
            this.inactiveChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchInactive(query).then((result) => {
                this.inactiveChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.inactiveChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed')
        }
    }

    fetchActive = async (query) => {
        try {
            this.activeChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchActive(query).then((result) => {
                this.activeChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.activeChannel.next({status: apiResponse.ERROR, data: error})
            })   
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed')
        }
    }

    fetchHours = async (query) => {
        try {
            this.hoursChannel.next({ status: apiResponse.LOADING })
            await this.repository.fetchHours(query).then((result) => {
                this.hoursChannel.next({ status: apiResponse.COMPLETED, data: result })
            }).catch((error) => {
                this.hoursChannel.next({ status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed')
        }
    }

    fetchRegion = async (query) => {
        try {
            this.regionChannel.next({ status: apiResponse.LOADING })
            await this.repository.fetchRegion(query).then((result) => {
                this.regionChannel.next({ status: apiResponse.COMPLETED, data: result })
            }).catch((error) => {
                this.regionChannel.next({ status: apiResponse.ERROR, data: error })
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed') 
        }
    }

    fetchApprove = async (query) => {
        try {
            this.approveChannel.next({ status: apiResponse.LOADING })
            await this.repository.fetchApprove(query).then((result) => {
                this.approveChannel.next({ status: apiResponse.COMPLETED, data: result })
            }).catch((error) => {
                this.approveChannel.next({ status: apiResponse.ERROR, data: error })
            })           
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed') 
        }
    }

}

export default DiklatBloc